import { POST } from '@/api'

/**
 * 祝日
 */
export default {
  namespaced: true,
  state: {
    list: [],
    busy: false,
  },
  mutations: {
    set(state, holidays) {
      state.list = holidays
    },
    busy(state, busy) {
      state.busy = busy
    },
  },
  getters: {
    all(state) {
      return state.list
    },
  },
  actions: {
    async get(store) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/holiday')

      if (status === 200) {
        commit('set', data.holidays)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
